import _cloneDeep from "lodash/cloneDeep"
import { ComputedRef, Ref } from 'vue'
import { Nullable } from 'frontcore/presentation/types'
import { SVGIconOption } from 'frontcore/views/icons/types'

export type SelectionLevelItems = {
  isDisabled?: boolean
  items: string[]
  icon?: SVGIconOption
}

export enum CheckboxState {
  UNCHECKED,
  CHECKED,
  INDETERMINATE
}

export class SelectionItem {
  parent: Nullable<SelectionItem>
  id: number
  category?: string
  label: string
  level: number
  isLastItem: boolean
  isDisabled: boolean
  children: SelectionItem[]
  levelItemsList?: SelectionLevelItems[]

  constructor (
    {parent, id, category, label, level, isLastItem, isDisabled, children, levelItemsList}:
    {
      parent: Nullable<SelectionItem>
      id: number
      category: string
      label: string
      level: number
      isLastItem: boolean
      isDisabled: boolean
      children: SelectionItem[]
      levelItemsList: SelectionLevelItems[]
    }
  ) {
    this.parent = parent
    this.id = id
    this.category = category
    this.label = label
    this.level = level
    this.isLastItem = isLastItem
    this.isDisabled = isDisabled
    this.children = _cloneDeep(children)
    this.levelItemsList = _cloneDeep(levelItemsList)
  }
}

export interface EnrichedSelectionItem extends SelectionItem {
  parentsLastItemPath: boolean[]
  state: CheckboxState
}

export type EmittedSelectionItem = {
  id: SelectionItem['id']
  value: CheckboxState
}

export type PerimeterItem = {
  id: number
  name: string
  parent: number
}

export type FactoryTreeItem = {
  id: number
  level: number
  name: string
  parent: number
  type: number
  items: PerimeterItem[]
}

export type SelectionVisualMultilevelUseCase = {
  filteredItems: ComputedRef<EnrichedSelectionItem[]>
  selectAllCheckboxState: ComputedRef<CheckboxState>
  searchText: Ref<string>
  flatFilterValues: ComputedRef<(string | number)[]>
  selectItem: (item: EnrichedSelectionItem) => void
  toggleSelectAll: () => void
  getChildrenIds: (item: SelectionItem) => number[]
}
